import type { ReactElement } from "react";
import type { LaborCostSection } from "@/pages/human-resources/time-management/business/analysis/LaborCostSection";
import { useTranslation } from "react-i18next";
import { formatNumber } from "@/shared/utils/Numbers.tsx";
import "./LaborCostDetailsSectionTotalRow.scss";
import useFormatDurationMinutes from "@/pages/human-resources/time-management/model/useFormatDurationMinutes.ts";

interface Props {
  section: LaborCostSection;
  hidden: boolean;
}

export function LaborCostDetailsSectionTotalRow({
  section,
  hidden,
}: Props): ReactElement {
  const { t } = useTranslation("common");
  const formatDuration = useFormatDurationMinutes();

  return (
    <tr
      className={hidden ? "section-total-row hidden-row" : "section-total-row"}
    >
      <td />
      <td className="cell-total-label">Total</td>
      <td />
      <td />
      <td className="cell-hours">{formatDuration(section.totalWorkMinutes)}</td>
      <td className="cell-hourly-rate">
        {formatNumber(t, section.totalHourlyRate, 2)} €
      </td>
      <td className="cell-contract-cost">
        {formatNumber(t, section.totalContractCost, 2)} €
      </td>
      <td className="cell-bonuses">
        {formatNumber(t, section.totalBonuses, 2)} €
      </td>
      <td className="cell-total-cost">
        {formatNumber(t, section.totalCost, 2)} €
      </td>
    </tr>
  );
}
